import React, { Component } from 'react';
import { connect } from 'react-redux';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { isObjectEmpty, hasCMSwUpdatePermission } from 'common/utils/helpers';
import { isItBundle } from 'common/utils/deviceTwinUtils';
import { LOADING_CIRCLE, DEVICES_PAGE_TAB, PERMISSION_ERROR_MESSAGE } from 'common/utils/constants';
import {
  setDropModalOpen,
  clearSelectedDevicesList,
  clearSelectedDevicesData,
  addToastNotification,
  doDeviceGroupUpdate,
  updateDevicesPageBulkActionModal,
  updateDevicesPageBulkCreateListModal,
  setMapSelectMode
} from 'redux/actions';
import { v4 } from 'uuid';
import DropModal from 'components/shared/DropModal/DropModal';
import classnames from 'classnames';
import ToastNotificationActionTypes from 'components/shared/ToastNotifications/constants';

class DeviceTableHeader extends Component {
  state = {
    actionPending: false
  };

  render() {
    const { deviceGroups, selectedDevicesDictionary } = this.props;
    const hasSwUpdatePermission = hasCMSwUpdatePermission(this.props.permissions);
    let devicesIds = [];
    let isADeviceSelected = false;
    if (this.props.mapSelectMode.bulk === true) {
      let keys = Object.keys(selectedDevicesDictionary);
      for (let i = 0; i < keys.length; i++) {
        if (selectedDevicesDictionary[keys[i]] === true) {
          devicesIds.push(keys[i]);
          isADeviceSelected = true;
        }
      }
    }

    // if (this.props.selectedDevicesData && Object.keys(this.props.selectedDevicesData).length !== 0) {
    //   isADeviceSelected = true;
    // }

    let selectedClass = isADeviceSelected ? 'DeviceTableHeader_Selected' : '';

    let addToListTitle = (
      <div className="Global_ThinBlueButton DeviceTableHeader_DevicesListButton">
        <IconAndText
          img={IconLoader.icon_add_devices}
          hoverImg={IconLoader.icon_add_devices}
          text={'Add to list'}
          tooltip={'Add selected devices to list'}
        />
      </div>
    );

    let overlay = null;
    if (this.state.actionPending) {
      overlay = <div className="Global_LoadingCircle_Overlay">{LOADING_CIRCLE}</div>;
    }

    let deviceGroupsDropdown = (
      <PerfectScrollbar>
        <div className="DeviceTableHeader_AddToListContainer">
          {!isObjectEmpty(deviceGroups) ? (
            Object.keys(deviceGroups).map((groupName, idx) => {
              let deviceGroup = deviceGroups[groupName];
              let { deviceGroupId, name, userId, devices } = deviceGroup;
              return (
                <div
                  key={idx}
                  className="DeviceTableHeader_AddToListContainer_Item_Div"
                  onClick={() => {
                    this.setState({ actionPending: true });
                    let newDevicesIds = [...devices];
                    devicesIds.forEach((deviceId) => {
                      let deviceObj = this.props.selectedDevicesData[deviceId];
                      let isBundle = isItBundle(deviceObj);
                      if (isBundle) {
                        let members = deviceObj.members;
                        members &&
                          members.forEach((item) => {
                            if (!newDevicesIds.includes(item.deviceId)) {
                              newDevicesIds.push(item.deviceId);
                            }
                          });
                      } else {
                        if (!newDevicesIds.includes(deviceId)) {
                          newDevicesIds.push(deviceId);
                        }
                      }
                    });
                    let cb_success = () => {
                      this.setState({ actionPending: false });
                      this.props.dispatch(setDropModalOpen('addToList', false));
                      this.props.dispatch(clearSelectedDevicesList(this.props.activeTab));
                      this.props.dispatch(clearSelectedDevicesData(this.props.activeTab));
                      this.props.onSelectDeviceGroup({ name: groupName });
                      this.props.dispatch(
                        addToastNotification({
                          id: v4(),
                          title: groupName,
                          description: 'Added to',
                          groupName: groupName,
                          actionType: ToastNotificationActionTypes.VIEW_DEVICE_LIST,
                          actionMessage: 'View the list',
                          reverse: true
                        })
                      );
                    };
                    let cb_failed = () => {
                      this.setState({ actionPending: false });
                      this.props.dispatch(setDropModalOpen('addToList', false));
                      this.props.dispatch(
                        addToastNotification({
                          id: v4(),
                          title: groupName,
                          description: 'Failed to add to',
                          groupName: groupName,
                          reverse: true
                        })
                      );
                    };
                    this.props.dispatch(
                      doDeviceGroupUpdate(
                        deviceGroupId,
                        name,
                        deviceGroup.default,
                        newDevicesIds,
                        userId,
                        cb_success,
                        cb_failed
                      )
                    );
                  }}
                >
                  <div className="DeviceTableHeader_AddToListContainer_Item_Text" data-tip={groupName}>
                    {groupName}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="DeviceTableHeader_AddToListContainer_NoListCreated_Div">
              <div className="DeviceTableHeader_AddToListContainer_NoListCreated_Text">No list has been created.</div>
            </div>
          )}
        </div>
      </PerfectScrollbar>
    );

    return (
      <div className={'DeviceTableHeader_OuterDiv ' + selectedClass}>
        <div className={'DeviceTableHeader_ChildrenDiv'}>{this.props.children}</div>
        {this.props.selectedDevicesData && Object.keys(this.props.selectedDevicesData).length !== 0 && (
          <div className={'DeviceTableHeader_ActionsDiv ' + selectedClass}>
            <div className="DeviceTableHeader_ActionListContainer">
              <div className="DeviceTableHeader_SoftwareUpdateButtonBox">
                <button
                  className={classnames({
                    Global_ThinBlueButton: true,
                    DeviceTableHeader_SWUpdateButton: true
                  })}
                  disabled={!hasSwUpdatePermission}
                  data-tip={hasSwUpdatePermission ? 'Software update' : PERMISSION_ERROR_MESSAGE}
                  onClick={() => {
                    hasSwUpdatePermission && this.props.dispatch(updateDevicesPageBulkActionModal(true));
                  }}
                >
                  Software Update
                </button>
              </div>
              <div className="DeviceTableHeader_CreateListButtonBox">
                <div className="Global_ThinBlueButton DeviceTableHeader_DevicesListButton">
                  <IconAndText
                    img={IconLoader.icon_create_plus}
                    hoverImg={IconLoader.icon_create_plus}
                    onClick={() => {
                      this.props.dispatch(updateDevicesPageBulkCreateListModal(true));
                    }}
                    text={'Create a list'}
                    tooltip={'Create a device list'}
                  />
                </div>
                <DropModal title={addToListTitle} name={'addToList'}>
                  {overlay}
                  {deviceGroupsDropdown}
                </DropModal>
              </div>
            </div>
            <div
              className={'DeviceTableHeader_CancelDiv ' + selectedClass}
              onClick={() => {
                this.props.dispatch(clearSelectedDevicesList(this.props.activeTab));
                this.props.dispatch(clearSelectedDevicesData(this.props.activeTab));
                this.props.dispatch(setMapSelectMode({ bulk: false, allSelect: false }));
              }}
            >
              <SvgAF img={IconLoader.icon_x} hover={IconLoader.icon_x_hover} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((store) => {
  const activeTab = store.ui.devicesPage.activeTab;
  let selectedDevicesDictionary;
  let selectedDevicesData;
  let mapSelectMode;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    selectedDevicesDictionary = store.ui.devicesPage.pivotTab.selectedDevicesDictionary;
    selectedDevicesData = store.data.selectedDevicesDataPivotTab;
    mapSelectMode = store.ui.devicesPage.pivotTab.selectMode;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    selectedDevicesDictionary = store.ui.devicesPage.echoTab.selectedDevicesDictionary;
    selectedDevicesData = store.data.selectedDevicesDataEchoTab;
    mapSelectMode = store.ui.devicesPage.echoTab.selectMode;
  } else {
    selectedDevicesDictionary = store.ui.devicesPage.allDevicesTab.selectedDevicesDictionary;
    selectedDevicesData = store.data.selectedDevicesDataAllDevicesTab;
    mapSelectMode = store.ui.devicesPage.allDevicesTab.selectMode;
  }

  return {
    activeTab,
    selectedDevicesDictionary,
    mapSelectMode,
    // mapSelectMode: store.ui.devicesPage.selectMode,
    deviceGroups: store.ui.devicesPage.deviceGroups,
    selectedDevicesData,
    permissions: store.data.rolePermissions.permissions
  };
})(DeviceTableHeader);
